<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<div class="frame-2">
<img alt="LSLFront.jpg" class="frame-1" src="image/LSLFront_fmt.jpeg"/>
</div>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LONHeFM00.vue?2b7e7ee8